import { applicationApi } from '../../common/api';
import { AnswerTodayQuiz, LksbGroupedHistory, LksbGroupedToday, TodayQuizQuestion } from './types';

// Define a service using a base URL and expected endpoints
export const lksbApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getTodayLksbGrouped: builder.query<LksbGroupedToday, void>({
      query: () => `lksb/grouped`,
    }),
    getHistoryLksbGrouped: builder.query<LksbGroupedHistory, void>({
      query: () => `lksb/grouped/history-daily`,
    }),
    getTodayQuiz: builder.query<TodayQuizQuestion, void>({
      query: () => `quiz/record/today`,
      providesTags: [{ type: 'QuizToday', id: 'LIST' }],
    }),
    answerTodayQuiz: builder.mutation<AnswerTodayQuiz, any>({
      query: (id) => ({
        url: `/quiz/record/answer/${id}`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'QuizToday', id: 'LIST' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTodayLksbGroupedQuery, useGetHistoryLksbGroupedQuery, useGetTodayQuizQuery, useAnswerTodayQuizMutation } = lksbApi;
